query packageGroupsSimple(
  $scenarioId: ID!
  $originId: ID!
  $filter: GroupsManagerSearchFilterInput!
) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    groupsManagerSearch(filter: $filter) {
      items {
        capacity
        id
        isReferent
        referentType
        enrollmentStats {
          capacity
          usedCapacity
          enrollmentsCount
          waitingListsCount
        }
      }
      pageInfo {
        size
        page
        total
        hasNextPage
        hasPreviousPage
      }
      __typename
    }
    __typename
  }
}
